import MUIDataTable from "mui-datatables";
import { lang } from "../Utils/lang";
import GenericDialog from "../Components/Reusable/GenericDialog";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { localUrlEnum, urlEnum } from "../Utils/urlEnum";
import { tableLayoutOnMobile } from "../Utils/Constants";
import { getData } from "../Services/getData";
import { getPropsFromUrl } from "../Utils/utils";
import moment from "moment";
import { europeanDate, usDateFormatWithTime } from "../Utils/formatDate";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteData } from "../Services/deleteData";
import { Button } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import GenericModal from "../Components/Reusable/GenericModal";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UserModel } from "../Models/UserModel";
import AddUser from "../Components/User/AddUser";
import { postData } from "../Services/postData";

export default function Users() {
  const navigate = useNavigate();
  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [nrUsers, setNrUsers] = useState(0);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { control, handleSubmit, getValues } = useForm({
    defaultValues: {
      rolesArray: ["ROLE_USER"],
    },
    resolver: yupResolver(UserModel),
  });

  const getUserDataForTable = () => {
    const search = getPropsFromUrl(location.search, "?");
    getData(
      `${urlEnum.users}?page=${search.page ? search.page : 0}&perPage=${
        search.perPage ? search.perPage : 10
      }`
    ).then((data: any) => {
      setUsers(data.data.results);
      setNrUsers(data.data.nrResults);
    });
  };

  useEffect(() => {
    getUserDataForTable();
  }, [location]);

  const companiesColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "email",
      label: lang.email,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "createdAt",
      label: lang.createAt,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (date: any) => (
          <>
            {date
              ? moment(date, usDateFormatWithTime).format(europeanDate)
              : ""}
          </>
        ),
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => (
          <div style={{ float: "right" }}>
            <DeleteIcon
              style={{
                height: 30,
                cursor: "pointer",
              }}
              onClick={(event: any) => {
                event.stopPropagation();
                setOpenDeleteModal(users[rowIndex]);
              }}
            />
          </div>
        ),
      },
    },
  ];

  /**
   *
   */
  const options = {
    filter: false,
    download: false,
    responsive: tableLayoutOnMobile,
    sort: false,
    textLabels: {
      viewColumns: {
        title: "Afisare coloane",
        titleAria: "Afisare Coloane",
      },
      pagination: lang.pagination,
    },

    fixedHeader: false,
    fixedSelectColumn: false,
    selectableRows: "none" as any,
    print: false,
    page: page,
    serverSide: true,
    rowsPerPage: perPage,
    search: false,
    count: nrUsers,
    rowHover: true,
    onChangePage: (page: number) => {
      setPage(page + 1);
      navigate(`${localUrlEnum.companies}?page=${page + 1}?perPage=${perPage}`);
    },
    onChangeRowsPerPage: (numberOfRows: number) => {
      setPerPage(numberOfRows);
      navigate(`${localUrlEnum.companies}?page=${1}?perPage=${numberOfRows}`);
      window.scrollTo(0, 0);
    },
  };

  /**
   *
   */
  function deleteUser() {
    const deleteUserUrl = `${urlEnum.deleteUser}?id=${
      (openDeleteModal as any).id
    }`;
    deleteData(deleteUserUrl).then((res) => {
      setOpenDeleteModal(false);
      getUserDataForTable();
    });
  }

  /**
   *
   */
  const addNewUser = () => {
    const newUserData = getValues();
    postData(urlEnum.addAdministratorUser, newUserData).then((res) => {
      setOpenAddUserModal(false);
      getUserDataForTable();
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", marginRight: 10 }}>
      <div
        style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}
      >
        <Button
          onClick={() => setOpenAddUserModal(true)}
          startIcon={<AddCircleIcon />}
          variant="contained"
          style={{
            color: "white",
            padding: "10px 15px 10px 15px",
            fontWeight: 600,
            borderRadius: "10px 10px 0px 0px",
            right: 0,
            zIndex: 1000,
          }}
        >
          {lang.addNewUser}
        </Button>
      </div>
      <MUIDataTable
        title={""}
        data={users}
        columns={companiesColumns}
        options={options}
      />
      <GenericDialog
        open={openDeleteModal}
        title={lang.deleteUser}
        message={lang.deleteUserMessage}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        onOk={() => deleteUser()}
        onCancel={() => {
          setOpenDeleteModal(false);
        }}
      />
      <GenericModal
        open={openAddUserModal}
        title={lang.addNewUser}
        content={<AddUser control={control} handleSubmit={handleSubmit} handleSubmitData={addNewUser} />}
        onClose={() => {
          setOpenAddUserModal(false);
        }}
        onOk={() => addNewUser()}
        onCancel={() => {
          setOpenAddUserModal(false);
        }}
        handleSubmit={handleSubmit(addNewUser)}
      />
    </div>
  );
}
